<template>
  <div class="ak-kanban__item">
    <component :is="element" :item="item" />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'AkKanbanItem',

  props: {
    component: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const element = computed(() => ({ ...props.component }))

    return {
      element,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-kanban__item {
  background-color: #fff;
  padding: $spacing-small;
  border-top: 2px solid #fff;
  border-radius: $base-border-radius;
  box-shadow: $base-shadow;
  margin-bottom: $spacing-small;
  min-height: 80px;
  display: block;
  width: 100%;
  color: inherit;
  transition: transform $transition-time, box-shadow $transition-time;
  cursor: pointer;
  // &:hover {
  //   box-shadow: $selectable-hover;
  //   color: inherit;
  // }
  &.is-assigned {
    border-top-color: $color-action;
  }
  &.is-overdue {
    border-top-color: $color-warning;
  }
  &.is-loading {
    transform: scale(1.05);
    box-shadow: $base-shadow;
    cursor: default;
  }
  &__loader {
    position: absolute;
    top: $spacing-tiny;
    right: $spacing-small;
    background-color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    box-shadow: $base-shadow;
    display: flex;
    justify-content: center;
    align-content: center;
    z-index: 4;
    margin-top: -2px;
    padding-top: 2px; // loading spinner tiny is a bit shitty
  }
  &__header-bar {
    padding-top: calc($spacing-tiny / 2);
    padding-bottom: calc($spacing-tiny / 2);
    padding-left: $spacing-small;
    padding-right: $spacing-small;
    margin-top: calc(-#{$spacing-tiny} - 2px);
    margin-left: -$spacing-small;
    margin-right: -$spacing-small;
    margin-bottom: $spacing-tiny;
    border-radius: $base-border-radius $base-border-radius 0 0;
    font-size: $font-size-smaller;
    font-weight: bold;
    text-align: right;
    white-space: nowrap;
  }
  &__more {
    position: absolute;
    bottom: $spacing-tiny;
    right: $spacing-tiny;
  }
}
</style>
